import React from 'react'
import styled from 'styled-components'
import { Container, MOBILE } from '../CustomLanding.styled'
import DashboardShot from '../Assets/dashboard-shot.jpg'
import { colors, experience } from '../content'

const ExperienceShot: React.FC = () => (
	<Section>
		<Split>
			<TextCol>
				<Title>{experience.title}</Title>
				<P>{experience.p1}</P>
				<P last>{experience.p2}</P>
				<Pills>
					{experience.pills.map(pill => (
						<Pill key={pill}>{pill}</Pill>
					))}
					<PillAccent>{experience.pillAccent}</PillAccent>
				</Pills>
				<Closing>{experience.closing}</Closing>
			</TextCol>
			<BrowserMock>
				<Dots>
					<Dot />
					<Dot />
					<Dot />
				</Dots>
				<Screen>
					<ScreenImg src={DashboardShot} alt={experience.shotCaption} />
				</Screen>
			</BrowserMock>
		</Split>
	</Section>
)

export default ExperienceShot

const Section = styled.section`
	background: #ffffff;
	padding: 64px 0;
	border-top: 1px solid rgba(22, 58, 132, 0.1);
	border-bottom: 1px solid rgba(22, 58, 132, 0.1);
	${MOBILE} {
		padding: 40px 0;
	}
`

const Split = styled(Container)`
	display: flex;
	flex-wrap: wrap;
	gap: 48px 72px;
	align-items: center;
	${MOBILE} {
		display: block;
	}
`

const TextCol = styled.div`
	flex: 1 1 380px;
	min-width: 0;
`

const Title = styled.h2`
	font-weight: 700;
	font-size: clamp(24px, 2.2vw, 34px);
	line-height: 1.35;
	color: ${colors.navy};
	margin: 0 0 26px;
	${MOBILE} {
		font-size: 28px;
		line-height: 1.4;
		margin-bottom: 18px;
	}
`

const P = styled.p<{ last?: boolean }>`
	margin: 0 0 ${p => (p.last ? '34px' : '14px')};
	font-size: 17px;
	line-height: 2;
	color: ${colors.body};
	${MOBILE} {
		font-size: 16px;
		line-height: 1.95;
		margin-bottom: ${p => (p.last ? '22px' : '10px')};
	}
`

const Pills = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 10px;
	margin-bottom: 34px;
	${MOBILE} {
		gap: 8px;
		margin-bottom: 24px;
	}
`

const Pill = styled.span`
	border: 1px solid rgba(22, 58, 132, 0.18);
	background: ${colors.paper};
	border-radius: 999px;
	padding: 11px 22px;
	font-size: 16px;
	font-weight: 500;
	color: ${colors.navy};
	${MOBILE} {
		padding: 10px 18px;
		font-size: 14px;
	}
`

const PillAccent = styled(Pill)`
	border-color: rgba(7, 126, 246, 0.35);
	background: rgba(7, 126, 246, 0.08);
	color: ${colors.blue};
`

const Closing = styled.p`
	margin: 0;
	font-size: 17px;
	font-weight: 600;
	line-height: 1.9;
	color: ${colors.navy};
	${MOBILE} {
		font-size: 17px;
		line-height: 1.85;
		margin-bottom: 24px;
	}
`

const BrowserMock = styled.div`
	flex: 1 1 360px;
	min-width: 0;
	border: 1px solid ${colors.line};
	border-radius: 24px;
	background: ${colors.paper};
	padding: 22px;
	${MOBILE} {
		border-radius: 20px;
		padding: 16px;
	}
`

const Dots = styled.div`
	display: flex;
	gap: 7px;
	margin-bottom: 18px;
	${MOBILE} {
		gap: 6px;
		margin-bottom: 14px;
	}
`

const Dot = styled.span`
	width: 10px;
	height: 10px;
	border-radius: 999px;
	background: rgba(22, 58, 132, 0.18);
	display: block;
	${MOBILE} {
		width: 9px;
		height: 9px;
	}
`

/* The real dashboard capture is wide (3185x1552); the screen keeps the
   image's own ratio instead of the placeholder's 4:3 so nothing is cropped. */
const Screen = styled.div`
	border-radius: 16px;
	background-color: #e9ebf1;
	overflow: hidden;
	${MOBILE} {
		border-radius: 14px;
	}
`

const ScreenImg = styled.img`
	display: block;
	width: 100%;
	height: auto;
`
